import { FC } from 'react';
import DropdownTable from '../DropdownTable';
import SearchFormItem from './subpage/searchFormItem';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { DropdownTableProps } from '../DropdownTable/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormDropdownTableProps extends BaseSearchFormItemProps {
  /** dropdownTable Props */
  dropdownTableProps?: DropdownTableProps;
}
/** 下拉表格 */
export const SearchFormDropdownTable: FC<SearchFormDropdownTableProps> = props => {
  const {
    dropdownTableProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || dropdownTableProps?.disabled}
      name={name}
      label={label}
      rules={rules}
      validateTrigger="onChange"
    >
      <DropdownTable
        allowClear
        showSearch
        test-id={`${testId}-${name}`}
        disabledRender={render || disabledRender}
        {...dropdownTableProps}
        disabled={isDetail || dropdownTableProps?.disabled}
        placeholder={getSelectPlaceholder(label, dropdownTableProps, rules)}
      />
    </SearchFormItem>
  );
};

SearchFormDropdownTable.displayName = SearchFormItemEnum.SearchFormDropdownTable;

export default SearchFormDropdownTable;
